


























































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name:'ISwitcher'
})
export default class ISwitcher extends Vue{
  @Prop({ type: Boolean, default() { return false; }}) switcherOn !:boolean

}
